import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpenIcon, BriefcaseIcon, FileTextIcon, UsersIcon, BuildingIcon, HandshakeIcon, WebhookIcon, PlayCircleIcon, ScrollTextIcon, CodeIcon } from 'lucide-react';
function MenuItem({
  icon: Icon,
  label,
  to
}: {
  icon: any;
  label: string;
  to: string;
}) {
  return <Link to={to} className="flex items-center gap-3 group/item" data-id="element-231">
      <div className="p-1.5 rounded-md bg-white/5 group-hover/item:bg-violet-electric/20 transition-colors" data-id="element-232">
        <Icon className="w-4 h-4 text-white/60 group-hover/item:text-violet-electric transition-colors" data-id="element-233" />
      </div>
      <span className="text-white/80 text-sm font-medium group-hover/item:text-white transition-colors" data-id="element-234">
        {label}
      </span>
    </Link>;
}
export function ResourcesMenu({
  onClose
}: {
  onClose?: () => void;
}) {
  return <div className="absolute top-full left-1/2 -translate-x-1/2 w-[850px] pt-3 z-50" onClick={onClose} data-id="element-235">
      <div className="bg-[#0D0B2E]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden" data-id="element-236">
        <div className="grid grid-cols-12 divide-x divide-white/10" data-id="element-237">
          {/* Left Column: Intro */}
          <div className="col-span-3 p-6 bg-white/[0.02] flex flex-col justify-between" data-id="element-238">
            <div data-id="element-239">
              <h3 className="text-white font-semibold text-sm tracking-wide mb-3" data-id="element-240">
                All Resources
              </h3>
              <p className="text-white/60 text-sm leading-relaxed" data-id="element-241">
                Explore our knowledge hub
              </p>
            </div>
          </div>

          {/* Middle Column: Resources */}
          <div className="col-span-3 p-6" data-id="element-242">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-243">
              Resources
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-244">
              <MenuItem icon={BookOpenIcon} label="Blog" to="/resources/blog" data-id="element-245" />
              <MenuItem icon={BriefcaseIcon} label="Case Studies" to="/resources/case-studies" data-id="element-246" />
              <MenuItem icon={PlayCircleIcon} label="Demo Videos" to="/resources/demo-videos" data-id="element-247" />
              <MenuItem icon={FileTextIcon} label="Our Thesis" to="/resources/thesis" data-id="element-248" />
            </div>
          </div>

          {/* Development Column */}
          <div className="col-span-3 p-6" data-id="element-249">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-250">
              Development
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-251">
              <MenuItem icon={WebhookIcon} label="Integrations" to="/resources/integrations" data-id="element-252" />
              <MenuItem icon={ScrollTextIcon} label="Changelog" to="/resources/changelog" data-id="element-253" />
            </div>
          </div>

          {/* Right Column: About */}
          <div className="col-span-3 p-6 bg-white/[0.02]" data-id="element-254">
            <h3 className="text-white/40 text-[10px] font-bold uppercase tracking-widest mb-4" data-id="element-255">
              About
            </h3>
            <div className="grid grid-cols-1 gap-y-3" data-id="element-256">
              <MenuItem icon={UsersIcon} label="Careers" to="/about/careers" data-id="element-257" />
              <MenuItem icon={BuildingIcon} label="About Us" to="/about" data-id="element-258" />
              <MenuItem icon={HandshakeIcon} label="Become A Partner" to="/partners" data-id="element-259" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}